import {serializeReviewAnalysisDate} from '../../../page/main/reviews-analysis/reviews-analysis-helper';
import {serialize} from '../../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent} from '../../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../api/api-const';

import {AiMessagePayloadType} from './review-analysis-ai-message-type';

export function sendMessageToReviewAnalysisAiChat(messagePayload: AiMessagePayloadType): Promise<unknown> {
    const {searchParams, filterKey, ...restMessagePayload} = messagePayload;

    const url = `${rootApiUrl}/cp/reviews_analytics/rocket_gpt/`;

    return fetchNoContent(url, {
        method: FetchMethodEnum.post,
        headers: {
            ...mainApiHeaders,
            ...getCsrfHeaders(),
        },
        body: JSON.stringify(
            serialize({
                searchParams: {
                    ...searchParams,
                    ...(searchParams.startDate
                        ? {
                              startDate: serializeReviewAnalysisDate(searchParams.startDate),
                          }
                        : {}),
                    ...(searchParams.endDate
                        ? {
                              endDate: serializeReviewAnalysisDate(searchParams.endDate),
                          }
                        : {}),
                },
                ...(filterKey ? {filterKey} : {}),
                ...restMessagePayload,
            })
        ),
    });
}
